// reduxjs toolkit
import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import BaseUrl from '../../service/API/base_url';
import { handleSuccess, handleError } from '../../utils/toast';

const handleApiResponse = (response, thunkAPI, successMessage) => {
  if (response.status === 200 || response.status === 201) {
    if (successMessage) handleSuccess(successMessage);
    return response.data;
  } else {
    handleError(response.message);
    return thunkAPI.rejectWithValue(response.data);
  }
};

const handleApiError = (error, thunkAPI, errorMessage) => {
  handleError(error.response?.data?.message || errorMessage);
  return thunkAPI.rejectWithValue(error.response?.data);
};

// List all Houses
export const viewHouse = createAsyncThunk('houses', async (_, thunkAPI) => {
  try {
    const response = await axios.get(`${BaseUrl}dorm-api/houses`);
    return handleApiResponse(response, thunkAPI);
  } catch (e) {
    return handleApiError(e, thunkAPI, 'loading...');
  }
});

// List only approved Houses
export const approvedHouseList = createAsyncThunk(
  'houses',
  async (_, thunkAPI) => {
    try {
      const response = await axios.get(`${BaseUrl}dorm-api/paginate-house`);
      // console.log('res : ', response);
      return handleApiResponse(response, thunkAPI);
    } catch (e) {
      return handleApiError(e, thunkAPI, 'loading...');
    }
  },
);

// Add new House
export const registerHouse = createAsyncThunk(
  'houses',
  async (HouseData, thunkAPI) => {
    try {
      const response = await axios.post(`${BaseUrl}dorm-api/houses`, HouseData);
      // console.log("response : ", response);
      return handleApiResponse(response, thunkAPI, 'Register successful!');
    } catch (e) {
      return handleApiError(e, thunkAPI);
    }
  },
);

// Search House by ID
export const singleHouse = createAsyncThunk('houses', async (id, thunkAPI) => {
  try {
    const response = await axios.get(`${BaseUrl}dorm-api/houses/${id}`);
    return handleApiResponse(response, thunkAPI);
  } catch (e) {
    return handleApiError(e, thunkAPI, 'search dorm history...');
  }
});

// Update House
export const updateHouse = createAsyncThunk(
  'house',
  async ({ id, formData }, thunkAPI) => {
    try {
      const response = await axios.put(
        `${BaseUrl}dorm-api/houses/${id}`,
        formData,
      );
      return handleApiResponse(response, thunkAPI, 'Change saved successfully');
    } catch (e) {
      return handleApiError(e, thunkAPI);
    }
  },
);

// Delete House
export const deleteHouse = createAsyncThunk('houses', async (id, thunkAPI) => {
  const token = JSON.parse(localStorage.getItem('userInfo')) || null;
  try {
    const response = await axios.delete(`${BaseUrl}dorm-api/houses/${id}`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return handleApiResponse(response, thunkAPI, 'Delete successful!');
  } catch (e) {
    return handleApiError(e, thunkAPI);
  }
});

// Single User Houses
export const singleUserHouse = createAsyncThunk(
  'houses',
  async (id, thunkAPI) => {
    try {
      const response = await axios.get(`${BaseUrl}dorm-api/users-house/${id}`);
      return handleApiResponse(response, thunkAPI);
    } catch (e) {
      return handleApiError(e, thunkAPI, 'search maintenance history...');
    }
  },
);

// Approve House
export const approveHouse = createAsyncThunk(
  'houses',
  async (HouseData, thunkAPI) => {
    const token = JSON.parse(localStorage.getItem('userInfo')) || null;

    try {
      const response = await axios.put(
        `${BaseUrl}dorm-api/house-approve/${HouseData.id}`,
        HouseData,
        {
          headers: { Authorization: `Bearer ${token}` },
        },
      );

      return handleApiResponse(response, thunkAPI, 'Approved successfully!');
    } catch (e) {
      return handleApiError(
        e,
        thunkAPI,
        'Please try again. Invalid credentials',
      );
    }
  },
);
